import { datadogRum } from '@datadog/browser-rum';
import { User } from '@upstart/harmony/lib/legos/userTypes';

// IMPORTANT: because we use `storeContextsAcrossPages` to maintain
// the `dealerIds` array, we cannot store any PII on this context
interface ChairmanGlobalContext {
  dealerIds?: string[];
  userId?: number;
  lastAccessedDealer?: string | null;
  lastAccessedDeal?: string;
}

function typedSetGlobalContextProperty<K extends keyof ChairmanGlobalContext>(
  key: K,
  value: ChairmanGlobalContext[K],
): void {
  datadogRum.setGlobalContextProperty(key, value);
}

export function setUser(user: User): void {
  datadogRum.setUser({
    id: String(user.id),
    type: user.type,
    roles: user.roles,
  });
}

export function dealerUsedInSession(dealerId: string | null): void {
  const ctx = datadogRum.getGlobalContext() as ChairmanGlobalContext;
  if (dealerId !== null) {
    const existingDealerIds = ctx.dealerIds || [];
    const newDealerIds = Array.from(new Set([...existingDealerIds, dealerId]));
    typedSetGlobalContextProperty('dealerIds', newDealerIds);
  }
  typedSetGlobalContextProperty('lastAccessedDealer', dealerId);
}

export function dealUsedInSession(dealId: string): void {
  typedSetGlobalContextProperty('lastAccessedDeal', dealId);
}
